import React, { useState } from "react";
import { AuthService } from "../auth";
import { ApiRoutes } from "../routes/routePaths";
import { UserDto } from "../endpoints";

export interface UserContextProviderProps {
  user: UserDto | undefined;
  logIn: (email: string, password: string) => Promise<void>;
  logOut: () => void;
  resendConfirmation: (email: string) => Promise<Response>;
}

export const UserContext = React.createContext<UserContextProviderProps>(
  {} as UserContextProviderProps
);

const UserContextProvider = (props) => {
  const [user, setUser] = useState<UserDto | undefined>(undefined);

  const logIn = async (email: string, password: string): Promise<void> => {
    const response = await fetch(ApiRoutes.LOGIN(email, password), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email,
        password,
      }),
    });

    if (!response.ok) {
      return Promise.reject(response);
    }

    const user: UserDto = await getUser();
    setUser(user);

    return Promise.resolve();
  };

  const logOut = async (): Promise<void> => {
    if (await AuthService.isLogged()) {
      AuthService.logout();
      setUser(undefined);
    }
    console.warn("logout() called yet user is not logged in");
  };

  const getUser = async (): Promise<UserDto> => {
    const response = await fetch(ApiRoutes.GET_USER, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      return Promise.reject();
    }

    const user = await response.json();
    return Promise.resolve(user);
  };

  const resendConfirmation = async (email: string): Promise<Response> => {
    return await fetch(ApiRoutes.RESEND_CONFIRMATION, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email,
      }),
    });
  };

  return (
    <UserContext.Provider
      value={{
        user,
        logIn,
        logOut,
        resendConfirmation,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
